<template>
    <div class="pull-right">
        <button class="btn btn-cancel modal-third" id="CancelButton" @click.prevent="confirmResetModal = true">Clear Judging Groups</button>

        <modal v-if="confirmResetModal" @close="confirmResetModal = false">
            <h3 slot="header">Judging Groups Reset</h3>
            <div class="content" slot="body">
                <p>Are you sure you want to reset the judging groups?</p>
            </div>
            <div class="form-group-submit" slot="footer">
                <button class="pull-left" @click="confirmResetModal = false">Close</button>
                <button class="btn btn-primary pull-right" @click.prevent="resetJudgeGroups">Yes, Delete</button>
            </div>
        </modal>
    </div>
</template>


<script>
// register modal component
import modal from '../components/Modal.vue';

export default {
    components: {modal},
    data() {
        return {
            confirmResetModal: false
        }
    },
    methods: {
        resetJudgeGroups: function() {
            let that = this;
            window.axios(
                {
                    method: 'post',
                    url: '/judge/reset'
                }).then(function(response) {
                location.reload();
            }).catch(function (error) {
                console.log('This is the error returned', error);
            });
        }
    }
}

</script>
